import React, { useContext, useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./TutorProfile.css";
import { AuthContextTwo } from "../../contexts/AuthProviderTwo";
import LoaderSmall from "../Shared/LoderSmall/LoaderSmall";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import LoadingPersonal from "../Shared/LoaderBigTwo/LoadingPersonal";

const firebaseConfig = {
  apiKey: "AIzaSyDHqLpPVzd0Y9SWTpSH1smRmbKv4WUvi-4",
  authDomain: "tutors-today-student.firebaseapp.com",
  projectId: "tutors-today-student",
  storageBucket: "tutors-today-student.appspot.com",
  messagingSenderId: "171808622362",
  appId: "1:171808622362:web:cb9ad091e01bba89988ea3",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const PersonalProfile = () => {
  const { userTwo } = useContext(AuthContextTwo);
  const [loading, setLoading] = useState(false);
  const [selectedLocation, setLocation] = useState(null);
  const [selectedAreaTwo, setAreaTwo] = useState(null);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    religion: "",
    fileUrl: "",
    city: "",
    area: "",
    emergencyNmbr: "",
  });

  //////////////////// Profile Data  start /////////////////////////
  const [profileData, setProfileData] = useState([]);
  const [Mainloading, setMainLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/user/${userTwo?.email}`
      );
      const data = await response.json();
      setProfileData(data);
      setMainLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setMainLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [isNameValid, setIsNameValid] = useState(
    profileData.area ||
      profileData.gender ||
      profileData.city ||
      profileData.emergencyNmbr
      ? true
      : false
  );
  const [uploadAttempted, setUploadAttempted] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  // Update useEffect to set isNameValid when profileData changes
  useEffect(() => {
    if (
      profileData.area ||
      profileData.gender ||
      profileData.city ||
      profileData.emergencyNmbr
    ) {
      setIsNameValid(true);
    }
  }, [profileData]);
  //////////////////// Profile Data  end   /////////////////////////
  const handleFileChange = (event) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles.length > 0) {
      const fileLabels = Array.from(uploadedFiles)
        .map((file) => file.name)
        .join(", ");
      document.getElementById("fileLabel").innerText = fileLabels;
      setFile(Array.from(uploadedFiles));
    } else {
      document.getElementById("fileLabel").innerText = "JPG / PNG / PDF";
      setFile([]);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const [isCityValid, setIsCityValid] = useState(true);
  const [isAreaValid, setIsAreaValid] = useState(true);
  const [isGenderValid, setIsGenderValid] = useState(true);
  const [isEmergencyNmbrValid, setIsEmergencyNmbrValid] = useState(true);

  const handleUpload = async () => {
    setLoading(true);
    setUploadAttempted(true); // Set that an upload attempt has been made

    // Check if name is required and not provided
    const isAnyProfileValid = profileData.some(
      (profile) =>
        profile.area && profile.gender && profile.city && profile.emergencyNmbr
    );

    const isFormDataValid =
      formData.area &&
      formData.gender &&
      formData.city &&
      formData.emergencyNmbr;
    // If no profile is valid, show an error and stop execution

    setIsCityValid(formData.city || profileData.city);
    setIsAreaValid(formData.area || profileData.area);
    setIsGenderValid(formData.gender || profileData.gender);
    setIsEmergencyNmbrValid(
      formData.emergencyNmbr || profileData.emergencyNmbr
    );

    if (
      !isCityValid ||
      !isAreaValid ||
      !isGenderValid ||
      !isEmergencyNmbrValid
    ) {
      setLoading(false);
      return;
    }
    if (!isAnyProfileValid && !isFormDataValid) {
      toast.error("Please fill up all the required fields.");
      setLoading(false);
      return; // Stop further execution
    }

    setIsNameValid(true); // Name is valid

    const updatedFormData = { ...formData };

    // Assuming you have a file upload process here
    if (file && file.length > 0) {
      const promises = [];

      file.forEach((uploadedFile, index) => {
        const storageRef = ref(storage, `uploads/${uploadedFile.name}`);
        promises.push(
          uploadBytes(storageRef, uploadedFile)
            .then((snapshot) => getDownloadURL(snapshot.ref))
            .then((downloadURL) => {
              updatedFormData[`fileUrl${index + 1}`] = downloadURL;
              return downloadURL;
            })
        );
      });

      try {
        await Promise.all(promises);
        console.log("Files uploaded successfully!");
      } catch (error) {
        console.error("Error uploading files: ", error);
        setLoading(false);
        return; // Stop further execution if file upload fails
      }
    }

    try {
      // Update the formData state
      setFormData(updatedFormData);

      // Assuming you have a function to update data on the server
      await updateDataOnServer(updatedFormData);

      // Display a success message to the user
      toast.success("Data submitted successfully!");
    } catch (error) {
      console.error("Error submitting form: ", error);
      toast.error("Error submitting data");
    } finally {
      setLoading(false);
    }
  };

  const updateDataOnServer = async (dataToUpdate) => {
    try {
      const updateResponse = await fetch(
        "https://tutor-tree-server-1.vercel.app/user/updateImage",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: userTwo.email,

            ...dataToUpdate,
          }),
        }
      );

      const updateData = await updateResponse.json();
      console.log("Data updated on the server:", updateData);
    } catch (error) {
      console.error("Error updating data on the server:", error);
    }
  };
  // Adjust the dropdown to have the name "district"

  ////////////////////////////////// khulna and chittagong area start ///////////////////////////////
  const [districts, setDistricts] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  const [KhulnaArea, setKhulnaArea] = useState([]);
  const fetchKhulnaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/khulnaArea");
      const data = await response.json();
      setKhulnaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchKhulnaArea();
  }, []);
  const [ChittagongArea, setChittagongArea] = useState([]);
  const fetchChittagongArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/ChittagongArea");
      const data = await response.json();
      setChittagongArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchChittagongArea();
  }, []);

  const [DhakaArea, setDhakaArea] = useState([]);
  const fetchDhakaArea = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/DhakaArea");
      const data = await response.json();
      setDhakaArea(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDhakaArea();
  }, []);
  ////////////////////////////////// khulna and chittagong area end   ///////////////////////////////

  return (
    <div>
      {Mainloading ? (
        <LoadingPersonal></LoadingPersonal>
      ) : (
        <div className="rounded-lg border-2">
          <div className="px-10 py-5 flex justify-between items-center">
            <h1 className="boxTag">Personal Information</h1>
          </div>
          <hr className="h-2"></hr>

          {profileData.map((profile) => (
            <div className="grid lg:grid-cols-3 sm:grid-cols-1 gap-5 px-5 sm:px-10">
              <div>
                <div className="translate-y-8 ml-5 bg-white w-24 flex justify-center items-center textMain">
                  Full Name
                </div>
                <input
                  type="text"
                  name="name"
                  placeholder={profile.name}
                  className="input border-2 border-orange-500  mt-5 h-[60px] input-warning w-full "
                  onChange={handleInputChange}
                />
                <div></div>
              </div>
              <div className="mt-5">
                <div className="translate-y-3 ml-5 bg-white w-24 flex justify-center items-center textMain">
                  Select City *
                </div>

                <select
                  required
                  name="city"
                  value={selectedLocation}
                  onChange={(e) => {
                    handleInputChange(e);
                    setLocation(e.target.value);
                  }}
                  className="h-[60px] select border-2 border-orange-500 select-error w-full "
                >
                  <option disabled selected>
                    {profile.city}
                  </option>
                  {districts.map((district, index) => (
                    <option key={index} value={district.district}>
                      {district.district}
                    </option>
                  ))}
                </select>
                <div>
                  {!isCityValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      "City is required"
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-5">
                {selectedLocation === "Chittagong" && (
                  <div>
                    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
                      Select Area *
                    </div>
                    <select
                      name="area"
                      className="h-[60px] select border-2 border-orange-500 select-error w-full"
                      onChange={(e) => {
                        handleInputChange(e);
                        setAreaTwo(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        {profile.area}
                      </option>
                      {ChittagongArea.map((area, index) => (
                        <option key={index} value={selectedAreaTwo}>
                          {area.area}
                        </option>
                      ))}
                    </select>
                    <div>
                      {!isAreaValid && (
                        <div className="text-red-500 text-sm mt-1 textAlert">
                          {profile.area ? "" : "Area is required"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {selectedLocation === "Khulna" && (
                  <div>
                    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
                      Select Location
                    </div>
                    <select
                      name="area"
                      className="h-[60px] select border-2 border-orange-500 select-error w-full"
                      onChange={(e) => {
                        handleInputChange(e);
                        setAreaTwo(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        {profile.area}
                      </option>
                      {KhulnaArea.map((area, index) => (
                        <option key={index} value={selectedAreaTwo}>
                          {area.area}
                        </option>
                      ))}
                    </select>
                    <div>
                      {!isAreaValid && (
                        <div className="text-red-500 text-sm mt-1 textAlert">
                          {profile.area ? "" : "Area is required"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {selectedLocation === "Dhaka" && (
                  <div>
                    <div className="translate-y-3 ml-5 bg-white w-32 flex justify-center items-center textMain">
                      Select Location
                    </div>
                    <select
                      name="area"
                      className="h-[60px] select border-2 border-orange-500 select-error w-full"
                      onChange={(e) => {
                        handleInputChange(e);
                        setAreaTwo(e.target.value);
                      }}
                    >
                      <option disabled selected>
                        {profile.area}
                      </option>
                      {DhakaArea.map((area, index) => (
                        <option key={index} value={selectedAreaTwo}>
                          {area.area}
                        </option>
                      ))}
                    </select>
                    <div>
                      {!isAreaValid && (
                        <div className="text-red-500 text-sm mt-1 textAlert">
                          {profile.area ? "" : "Area is required"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div>
                <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
                  Gender *
                </div>

                <select
                  name="gender"
                  onChange={handleInputChange}
                  className="h-[60px] select border-2 border-orange-500 select-error w-full "
                >
                  <option disabled selected>
                    {profile.gender}
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
                <div>
                  {!isGenderValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      {profile.gender ? "" : "Gender is required"}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className="translate-y-3 ml-5 bg-white w-20 flex justify-center items-center textMain">
                  Religion
                </div>

                <select
                  name="religion"
                  onChange={handleInputChange}
                  className="h-[60px] select border-2 border-orange-500 select-error w-full "
                >
                  <option disabled selected>
                    {profile.religion}
                  </option>
                  <option value="Islam">Islam</option>
                  <option value="Hinduism">Hinduism </option>
                  <option value="Buddhism">Buddhism</option>
                  <option value="Christianity">Christianity</option>
                </select>
              </div>
              <div>
                <div className="translate-y-2 ml-5 bg-white w-56 flex justify-center items-center textMain">
                  Emergency Contact Number *
                </div>
                <input
                  type="number"
                  name="emergencyNmbr"
                  placeholder={profile.emergencyNmbr}
                  className="input border-2 border-orange-500  h-[60px] input-warning w-full "
                  onChange={handleInputChange}
                />
                {!isEmergencyNmbrValid && (
                  <div className="text-red-500 text-sm mt-1 textAlert">
                    {profile.emergencyNmbr ? "" : "Emergency Number required"}
                  </div>
                )}
              </div>
              <div>
                <div className="translate-y-3 ml-5 bg-white w-60 flex justify-center items-center textMain">
                  NID / Birth Certificate / Passport
                </div>

                <div className="border-2 border-orange-400  py-5 flex justify-between px-5 rounded-xl h-[60px]">
                  <div>
                    <input
                      type="file"
                      id="fileInput"
                      accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      multiple
                    />
                    <button
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <h1 className="font-semibold text-sm" id="fileLabel">
                        JPG / PNG / PDF
                      </h1>
                    </button>
                  </div>

                  <div>
                    <button
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M11.2435 18.7566C11.2435 19.0863 11.1125 19.4026 10.8793 19.6358C10.6461 19.869 10.3298 20 10 20C9.67025 20 9.35397 19.869 9.12078 19.6358C8.8876 19.4026 8.75658 19.0863 8.75658 18.7566L8.76537 11.2347L1.24343 11.2435C0.913656 11.2435 0.597389 11.1125 0.364192 10.8793C0.131007 10.6461 0 10.3298 0 10C0 9.67027 0.131007 9.35399 0.364192 9.12081C0.597389 8.88762 0.913656 8.7566 1.24343 8.7566L8.76537 8.7654L8.75658 1.24343C8.75658 0.913656 8.8876 0.597377 9.12078 0.364192C9.35397 0.131007 9.67025 0 10 0C10.3298 0 10.6461 0.131007 10.8793 0.364192C11.1125 0.597377 11.2435 0.913656 11.2435 1.24343L11.2347 8.7654L18.7567 8.7566C19.0864 8.7566 19.4027 8.88762 19.6359 9.12081C19.8691 9.35399 20.0001 9.67027 20.0001 10C20.0001 10.3298 19.8691 10.6461 19.6359 10.8793C19.4027 11.1125 19.0864 11.2435 18.7567 11.2435L11.2347 11.2347L11.2435 18.7566Z"
                          fill="#FE7702"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="flex mt-10 mx-10">
            <div>
              {loading ? (
                <button
                  onClick={handleUpload}
                  className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-orange-400 text-white rounded my-5"
                >
                  <LoaderSmall />
                </button>
              ) : (
                // Show the loader when uploading
                <button
                  onClick={handleUpload}
                  className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-orange-400 text-white rounded my-5"
                >
                  SUBMIT
                </button>
              )}
            </div>
            <div className="lg:ml-10 sm:ml-4">
              <Link to="/dashboardTwo/tutorProfile">
                <button className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-transparent border-2 border-gray-400 buttonMjr transition duration-300 ease-in-out rounded my-5 hover:bg-slate-700 hover:text-white hover:border-slate-700">
                  Cancel
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalProfile;
